module.exports = __webpack_public_path__ + "img/4_108.48516e9b.png";